module.exports = __webpack_public_path__ + "img/11088026_L.a6c11dd4.png";